import { Temporal, parseInstant } from '@shared/lib/date-time';

import type { MessengerMessage } from '../model/types';

type MessageTime = Pick<MessengerMessage, 'id' | 'sent_at' | 'created_at'>;
type Timed<T extends MessageTime> = { message: T; instant: Temporal.Instant | null };

const timed = <T extends MessageTime>(message: T): Timed<T> => ({
  message,
  instant: parseInstant(message.sent_at ?? message.created_at),
});

const compareTimed = (a: Timed<MessageTime>, b: Timed<MessageTime>): number => {
  const order =
    a.instant && b.instant ? Temporal.Instant.compare(a.instant, b.instant) : a.instant ? -1 : b.instant ? 1 : 0;
  return order || a.message.id.localeCompare(b.message.id);
};

/** Моменты по возрастанию, затем id; неизвестные даты в конце. Каждый момент парсится один раз. */
export function sortByMessageTime<T extends MessageTime>(messages: readonly T[]): T[] {
  return messages
    .map(timed)
    .sort(compareTimed)
    .map(({ message }) => message);
}
